import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button/index';
import Dialog from '@material-ui/core/Dialog/index';
import DialogActions from '@material-ui/core/DialogActions/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DialogTitle from '@material-ui/core/DialogTitle/index';
import Zoom from '@material-ui/core/Zoom';
import Fab from "@material-ui/core/Fab";
import {VentasService} from '../../../../services/_Sis/VentasService/VentasService';
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Tooltip from "@material-ui/core/Tooltip";
import DraggableModal from "../../../Include/DraggableModal/DraggableModal";
import IntegrationNotistack, {ShowSnackBarsNotistack} from "../../../../settings/IntegrationNotistack/IntegrationNotistack";
import {EnteroSolo, FieldsJs, hideSpinner, showSpinner} from "../../../../settings/General/General";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import {EditOutlined, HdrStrong, SearchOutlined} from "@material-ui/icons";
import {CatService} from "../../../../services/_Cat/CatService/CatService";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";


class ModalEstatus extends Component {
	
	state = {};
	
	constructor(props) {
		
		super(props);
		
		this.state = {
			open: false,
			scroll: 'paper',
			id_venta: (props.item || '').id_venta,
			id_cat_tipo_mensajeria: (props.item || '').id_cat_tipo_mensajeria,
			tipo: props.tipo,
			numero_rastreo: '',
			id_cat_venta_status_proceso: '',
			lista_cat_venta_status_proceso: [],
		};
		
	}
	
	showSnackBars = (type, message) => {
		ShowSnackBarsNotistack(this.props, type, message, null);
	};
	
	handleChange = (e, variable, campo, date, input) => {
		FieldsJs.HandleChange(e, variable, campo, date, input, (r) => this.setState({
			[r.name]: r.value
		}));
	};
	
	changeValue = (arr_name__key, var_name, var_value) => {
		FieldsJs.ChangeValue(arr_name__key, var_name, var_value, (r) => this.setState({
			[r.name]: r.value
		}), this.state);
	};
	
	openModal = () => {
		this.setState({open: true, scroll: 'paper'});
	};
	
	modalClose = () => {
		this.setState({open: false});
	};
	
	ListCatCronogramaEstatus = () => {
		return new Promise((resolve, reject) => {
			CatService.ListCatVentaProceso().then((response) => {
				this.setState({
					lista_cat_venta_status_proceso: response.data,
				});
				resolve(response);
			}).catch((error) => {
				this.setState({lista_cat_venta_status_proceso: []});
				this.showSnackBars('error', error.mensaje);
			});
		});
	};
	
	
	save = () => {
		try {
			VentasService.Estatus(this.state).then((response) => {
				this.props.RefreshList();
				this.modalClose();
				this.showSnackBars('success', response.mensaje);
			}).catch((error) => {
				this.showSnackBars('error', error.mensaje);
			});
		} catch (error) {
			this.showSnackBars('error', error.mensaje);
		}
	};
	
	add = () => {
		
		console.log(this.props);
		const {item} = this.props;
		
		this.setState({
			id_venta: item.id_venta || '',
			id_cat_venta_status_proceso: '',
			lista_cat_venta_status_proceso: [],
			activo: true,
		});
		
		this.ListCatCronogramaEstatus();
		this.openModal();
		
	};
	
	edit = () => {
		
		const {item} = this.props;
		
		console.log(this.props);
		
		this.setState({
			id_venta: item.id_venta || '',
			id_cat_tipo_mensajeria: item.id_cat_tipo_mensajeria || '',
			numero_rastreo: item.numero_rastreo || '',
			id_cat_venta_status_proceso: item.id_cat_venta_status_proceso.toString() || null,
			lista_cat_venta_status_proceso: item.lista_cat_venta_status_proceso || [],
			activo: (item.activo === 1),
		});
		
		this.ListCatCronogramaEstatus();
		
		this.openModal('paper');
		
	};
	
	view = () => {
		
		const {item} = this.props;
		
		console.log(this.props);
		
		this.ListCatCronogramaEstatus().then(() => {
			this.setState({
				id_cat_proyecto: item.id_cat_proyecto || '',
			});
			
		});
		
		this.setState({
			id_venta: item.id_venta || '',
			id_cat_venta_status_proceso: item.id_cat_venta_status_proceso || null,
			lista_cat_venta_status_proceso: item.lista_cat_venta_status_proceso || [],
			activo: (item.activo === 1),
		});
		
		this.openModal('paper');
		
	};
	
	BOTON_ACCION = () => {
		var BTN_ACTION = '';
		
		if (this.state.id_venta > 0) {
			if (this.state.tipo === 'edit') {
				BTN_ACTION = (
					<Tooltip TransitionComponent={Zoom} placement={"top"} title="Estatus">
						<IconButton aria-label="Estatus" onClick={() => this.edit()}>
							<HdrStrong/>
						</IconButton>
					</Tooltip>
				);
			} else if (this.state.tipo === 'view') {
				BTN_ACTION = (
					<Tooltip TransitionComponent={Zoom} placement={"top"} title="Detalles">
						<IconButton aria-label="Detalles" onClick={() => this.view()}>
							<SearchOutlined/>
						</IconButton>
					</Tooltip>
				);
			}
		} else {
			BTN_ACTION = (
				<Zoom className={'btn-fixed-bottom-right cursor-pointer'} key={'inherit'} timeout={1500} in={true}
				      style={{transitionDelay: `${100}ms`}} unmountOnExit>
					<Fab color={'primary'} onClick={() => this.add()}>
						<HdrStrong/>
					</Fab>
				</Zoom>
			);
		}
		return BTN_ACTION;
	};
	
	render() {
		
		const classes = {};
		
		const BTN_ACTION = this.BOTON_ACCION();
		
		return (
			<div>
				
				{BTN_ACTION}
				
				<Dialog disableBackdropClick disableEscapeKeyDown maxWidth={'sm'} open={this.state.open}
				        fullWidth={true} scroll={this.state.scroll} onClose={this.modalClose}
				        aria-labelledby="scroll-dialog-title"
				        PaperComponent={DraggableModal}
				>
					
					<DialogTitle>{'Actualizar Estatus'}</DialogTitle>
					
					<DialogContent className={'padding-20'}>
						
						<Grid container spacing={2}>
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12} className={'text-left'}>
								{/*<span className={'text-left text-black px-13'}>Estatus de la actividad:</span>*/}
								<Grid item className={'text-left ticketfrecuencia'} xs={12} sm={12} md={12} lg={12} xl={12}>
									<RadioGroup
										row aria-label="position"
										name="id_cat_venta_status_proceso"
										value={this.state.id_cat_venta_status_proceso}
										onChange={this.handleChange}>
										{this.state.lista_cat_venta_status_proceso.map((item, key) => (
											<FormControlLabel
												style={{color: 'gray', fontSize: '13px'}}
												key={key}
												labelPlacement="end"
												control={<Radio color="primary"/>}
												value={item.id_cat_venta_status_proceso.toString()}
												label={item.venta_status_proceso}
											/>
										))}
									</RadioGroup>
								</Grid>
							</Grid>
							
							{Number(this.state.id_cat_venta_status_proceso) === 4 ? (
								<Fragment>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										<Typography variant="body2" color="textSecondary" component="p" style={{fontWeight: 500, color: "black"}}>
											Agrega el código de rastreo para el cliente:
										</Typography>
									</Grid>
									
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										<TextField
											fullWidth
											onChange={this.handleChange}
											disabled={this.state.tipo === 'view'}
											type="text"
											margin="none"
											required
											//onKeyPress={EnteroSolo}
											//inputProps={{maxLength: 10}}
											name="numero_rastreo"
											label="Código de rastreo"
											value={this.state.numero_rastreo}
										/>
									</Grid>
								</Fragment>
							) : null}
							
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12} className={'text-left'}>
								
								<Grid container spacing={0}>
									
									<Grid item xs={6} sm={6} md={6} lg={6} xl={6} className={'text-left'}>
										<Button onClick={() => this.modalClose()} color="primary">
											{this.state.tipo === 'view' ? 'Cerrar' : 'Cancelar'}
										</Button>
									</Grid>
									
									<Grid item xs={6} sm={6} md={6} lg={6} xl={6} className={'text-right'}>
										{this.state.tipo !== 'view' ? (
											<Button onClick={() => this.save()} color="primary">
												{this.state.id_venta > 0 ? 'Actualizar' : 'Agregar'}
											</Button>
										) : ''}
									
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</DialogContent>
					
					{/*<DialogActions>
					
					
					
					
					</DialogActions>
				*/}
				</Dialog>
			
			</div>
		);
	}
}

ModalEstatus.propTypes = {
	componente: PropTypes.element,
	tipo: PropTypes.string.isRequired,
	item: PropTypes.object.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired
};

export default IntegrationNotistack(ModalEstatus);
